module Meevo.Plugins.Paging {

    interface IPagingService {
        getPagingSettings(request?: any): angular.IPromise<any>;
        updatePagingSettings(request?: any): angular.IPromise<any>;
    }

    interface IPagingSettings {
        pagingEnable: boolean;
        appointmentCheckInEnable: boolean;
        noShowEnable: boolean;
        runningLateEnable: boolean;
    }

    export class PagingService implements IPagingService {

        static $inject = [
            'meevo.components.common.DataService',
            'meevo.AppSettings',
            'meevo.components.tracking.TrackingService'
        ];

        constructor(
            public dataService: Meevo.Components.BaseClasses.IDataService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected trackingService: Meevo.Components.Tracking.ITrackingService
        ) { }

        getPagingSettings(request?: any): angular.IPromise<any> {
            return this.dataService.getItem('Settings/PagingFields');
        }

        updatePagingSettings(request?: any): angular.IPromise<any> {
            return this.dataService.update('Settings/PagingFields', request);
        }
        
    }

    angular.module('meevo.plugins.paging')
        .service('meevo.plugins.paging.PagingService', PagingService);
}